import React from "react";
import Layout from "../Layout";
import { Helmet } from "react-helmet";

const Partenaires = () => {
  console.log("Page Partenaires");
  return (
    <>
      <Helmet>
        <title>Partenaires | Vialle Construction</title>
        <meta
          name="description"
          content="Vialle Construction vous propose des partenaires de confiance pour la réalisation de votre projet"
        />
        <link
          rel="canonical"
          href="https://vialleconstruction.ca/Partenaires"
        />
        <meta property="og:title" content="Partenaires | Vialle Construction" />
        <meta
          property="og:description"
          content="Vialle Construction vous propose des partenaires de confiance pour la réalisation de votre projet"
        />
        <meta
          property="og:url"
          content="https://vialleconstruction.ca/Partenaires"
        />
        <meta
          property="og:image"
          content="https://vialleconstruction.ca/assets/logo.png"
        />
      </Helmet>
      <Layout>
        <div className="PartenairesPage">
          <img
            src="./assets/miniature/partenaires2.webp"
            alt="fond d'écran"
            style={{ display: "none" }}
          />
          <div className="title">
            <h1>nos partenaires</h1>
            <p>de confiance</p>
          </div>
          <p className="description">
            Dans le monde dynamique de la construction les défis sont nombreux,
            ils nécessitent une planification minutieuse, une coordination
            rigoureuse et une exécution précise. La solidité des relations, la
            confiance entre chaque acteur du projet permet la réussite de
            celui-ci. C’est pourquoi nous mettons en avant et nous remercions
            nos partenaires.
          </p>
          <ul>
            <li>
              <a
                href="https://www.facebook.com/christophelartisan"
                target="_blank"
              >
                Christophe l'artisant
              </a>
            </li>
            <li>
              <a>Solaris électrique inc</a>
            </li>
            <li>
              <a href="https://shop.bourcierventilation.com" target="_blank">
                <img
                  src="./assets/miniature/partenaires/ventilation.webp"
                  alt="logo entreprise Bourcier ventilation"
                />
                Bourcier ventilation
              </a>
            </li>
            <li>
              <a href="https://www.multigestionnd.com/" target="_blank">
                Multi-gestion
              </a>
            </li>
            <li>
              <a href="https://www.gopassif.com" target="_blank">
                <img
                  src="./assets/miniature/partenaires/go.webp"
                  alt="logo entreprise Go passif"
                />
                Go passif
              </a>
            </li>
            <li>
              <a>N. Wilson Service conseil Inc</a>
            </li>
            <li>
              <a href="https://iso-slab.com" target="_blank">
                <img
                  src="./assets/miniature/partenaires/iso.jpg"
                  alt="logo entreprise iso-slab"
                />
                Iso-Slab
              </a>
            </li>
          </ul>
        </div>
      </Layout>
    </>
  );
};

export default Partenaires;
